import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { PropType } from "vue";

import { IService } from "@/types/identifier";
import { formatCurrency } from "@/utils";
import { useStore } from "@/use/useStore";

import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AvailableServices',
  props: {
  services: { type: Array as PropType<IService[]>, default: () => [] },
},
  setup(__props) {



const { currentUser } = useStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiGroup, null, {
    header: _withCtx(() => [
      _createVNode(UiHeader, { title: "Доступные для заказа" })
    ]),
    default: _withCtx(() => [
      _createVNode(UiCard, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.services, (service) => {
            return (_openBlock(), _createBlock(UiCell, {
              key: service.id,
              title: service.name,
              href: `https://z.edu28.ru/pay?score_id=${_unref(currentUser)?.score_id}&service_id=${service.id}&target=${service.target}`,
              target: "_blank",
              rel: "noreferrer",
              expandable: ""
            }, {
              left: _withCtx(() => [
                (service.type == 0)
                  ? (_openBlock(), _createBlock(UiIcon, {
                      key: 0,
                      icon: "CreditCard"
                    }))
                  : _createCommentVNode("", true),
                (service.type == 1)
                  ? (_openBlock(), _createBlock(UiIcon, {
                      key: 1,
                      icon: "Chip"
                    }))
                  : _createCommentVNode("", true),
                (service.type == 2)
                  ? (_openBlock(), _createBlock(UiIcon, {
                      key: 2,
                      icon: "Support"
                    }))
                  : _createCommentVNode("", true),
                (service.type == 3)
                  ? (_openBlock(), _createBlock(UiIcon, {
                      key: 3,
                      icon: "Wifi"
                    }))
                  : _createCommentVNode("", true)
              ]),
              right: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(service.price / 100)), 1)
              ]),
              _: 2
            }, 1032, ["title", "href"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})